import { isLoggedIn } from './utils/is-logged-in';
import './svg-sprite';
import './navigation';
import './fuf';

// NOTE: only load if necessary since this brings React onto the page
if ( isLoggedIn() ) {
	import( './csp-violation-hint' ).then( ( { initCspViolationHint } ) =>
		initCspViolationHint()
	);
}
